"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Terms() {
  const headline = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const lead = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const list = useRevealOnScroll<HTMLUListElement>({
    threshold: 0.1
  });
  const principles = [{
    name: "Service Agreement",
    detail: "Our consulting services are provided as architectural guidance. We do not manage daily field operations or dispatch crews; we build the systems that empower you to do so."
  }, {
    name: "System Integrity",
    detail: "All software configurations and integrations are delivered as intellectual property of the client upon final payment. We maintain documentation for all custom builds."
  }, {
    name: "Liability Limitations",
    detail: "CSOS is not responsible for business outcomes resulting from the use of configured systems. We provide the tools; you maintain the operational control."
  }, {
    name: "SMS Communications Program",
    detail: "By opting into CSOS text communications, you agree to receive system notifications, operational notices, and marketing messages. You can cancel the SMS service at any time by texting \"STOP\". After you send the SMS message \"STOP\" to us, we will send you an SMS message to confirm that you have been unsubscribed. If you experience issues with the messaging program, you can reply with the keyword \"HELP\" for more assistance. Message frequency varies. Message and data rates may apply. Carriers are not liable for delayed or undelivered messages."
  }];
  return <section data-section-id="19475" id="terms-and-conditions" className="bg-background py-32 md:py-44 font-default text-foreground">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-4 md:gap-6">
          <h2 ref={headline.ref} style={{
          fontSize: "clamp(2.5rem, 9vw, 9rem)",
          lineHeight: 0.92,
          letterSpacing: "-0.025em",
          transitionDelay: "0ms"
        }} className={["col-span-12 lg:col-span-9 font-medium text-foreground", "transition-all duration-500 ease-[cubic-bezier(0.2,0.7,0.2,1)]", headline.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"].join(" ")}>
            Terms of engagement for modern trade infrastructure.
          </h2>
        </div>

        <div className="mt-20 md:mt-24 grid grid-cols-12 gap-4 md:gap-6">
          <p ref={lead.ref} style={{
          fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
          lineHeight: 1.55,
          letterSpacing: "-0.005em",
          transitionDelay: "120ms"
        }} className={["col-span-12 md:col-span-5 text-foreground font-normal", "transition-all duration-500 ease-[cubic-bezier(0.2,0.7,0.2,1)]", lead.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"].join(" ")}>
            We believe in transparency and clear boundaries. As architects of your digital backend, our role is to build robust, scalable systems that modernize your trade business. These terms outline our professional relationship, ensuring that both parties understand the scope of our technical craftsmanship and the responsibilities inherent in managing your own operational data. We prioritize clarity over complexity, ensuring your infrastructure is built to last.
          </p>

          <div className="hidden md:block md:col-span-1" />

          <ul ref={list.ref} className="col-span-12 md:col-span-6">
            {principles.map((principle, i) => <li data-index={i} key={principle.name} style={{
            transitionDelay: `${200 + i * 60}ms`
          }} className={["border-t border-border", i === principles.length - 1 ? "border-b" : "", "py-6 md:py-7", "flex flex-col md:flex-row md:items-baseline md:justify-between gap-2 md:gap-8", "transition-all duration-500 ease-[cubic-bezier(0.2,0.7,0.2,1)]", list.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"].join(" ")}>
                <h3 style={{
              fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
              lineHeight: 1.3,
              letterSpacing: "-0.005em"
            }} className="font-default font-medium text-foreground md:flex-1 md:max-w-[14rem]">
                  {principle.name}
                </h3>
                <p className="text-[16px] leading-[1.6] text-muted-foreground font-normal md:flex-1 md:text-right">
                  {principle.detail}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}